interface IProps {
	blob: Blob;
	readingOption: "readAsText" | "readAsDataURL" | "readAsArrayBuffer";
}

// чтение данных из файла
const readDataFromBlobAsync = async ({ blob, readingOption }: IProps) => {
	return new Promise((resolve, reject) => {
		const reader = new FileReader();

		// успешное чтение
		reader.onload = () => {
			resolve(reader.result);
		};

		// обработка ошибок
		reader.onerror = () => {
			reject(reader.error);
		};

		reader[readingOption](blob);
	});
};

export default readDataFromBlobAsync;
